app.directive('selectSingleCustom', ['$filter', function ($filter) {
    return {
        restrict: 'EA',
        replace: true,
        transclude: true,
        scope: {
            'title': '@',
            'default': '@',
            'disable': '=',
            'removeTitle': '@',
            'data': '=',
            'selectedText': '=',
            'selectedItem': '=',
            'classDropdown': '@'
        },
        templateUrl: "application/templates/directives/selectSingleCustom.html",
        controller: function ($scope) {
            $scope.hideSpan = $scope.default ? true : false;
            $scope.selectedItem = $scope.selectedItem ? $scope.selectedItem : null;

            $scope.config = {
                setHeight: 40 * $scope.data.length
            };

            $scope.changeValue = function (item) {
                $scope.hideSpan = $scope.default ? true : false;
                $scope.selectedItem = item;
            };

        }
    }
}]);

app.directive('selectSingleCustom2', ['$filter', function ($filter) {
    return {
        restrict: 'EA',
        replace: true,
        transclude: true,
        scope: {
            'title': '@',
            'default': '=',
            'disable': '=',
            'removeTitle': '@',
            'data': '=',
            'classDropdown': '@',
        },
        templateUrl: "application/templates/directives/selectSingleCustom2.html",
        controller: function ($scope) {
            $scope.$watch('data', function (newValue) {
                $scope.hideSpan = $scope.default ? true : false;

                $scope.default = $scope.default ? $scope.default : null;

                $scope.config = {
                    setHeight: 500
                    //setHeight: 40 * $scope.data.length
                };

                $scope.changeValue = function (value) {
                    $scope.default = value;
                    $scope.hideSpan = $scope.default ? true : false;
                };
            }.bind());
        }
    }
}]);

//Directive for Key press on element
app.directive('dlKeyCode', function dlKeyCode() {
    return {
        restrict: 'A',
        link: function ($scope, $element, $attrs) {
            $element.bind("keypress", function (event) {
                var keyCode = event.which || event.keyCode;

                if (keyCode == $attrs.code) {
                    $scope.$apply(function () {
                        $scope.$eval($attrs.dlKeyCode, { $event: event });
                    });

                }
            });
        }
    };
})

//Set auto focus to element on state load
app.directive('autoFocus', function ($timeout) {
    return {
        link: function (scope, element, attrs) {
            $timeout(function () {
                element.focus();
            });
        }
    }
});

app.filter('translateO', ['$translate', function ($translate) {
    return function (input) {
        
        if (input !== undefined) {
            var obj = JSON.parse(input);
            var result = "";
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    var params = obj[key].Params;
                    var desc = obj[key].Description;
                    if (desc !== null) {
                        desc = $translate.instant(desc);
                        for (var param in params) {
                            if (params.hasOwnProperty(param)) {
                                var k = "{" + param + "}";
                                var val = params[param];
                                if (param == "StatusId") {
                                    val = $translate.instant(param + params[param]);
                                }
                                desc = desc.replace(k, val);
                            }
                        }

                        result += desc + "; ";
                    }


                }
            }
        }
        return result;
    };
}]);
app.directive('includeReplace', function () {
    return {
        require: 'ngInclude',
        restrict: 'A', /* optional */
        link: function (scope, el, attrs) {
            el.replaceWith(el.children());
        }
    };
});

app.directive('myNginclude', function () {
    return {
        restrict: 'E',
        link: function (scope, element, attrs) {
            scope.getContentUrl = function () {
                return attrs.contenturl;
            }
            scope.initMasonry = function (c) {
                //we need to be sure that all ng-includes are done rendering, before init masonry
                var countMasonryBrick = jQuery('.masonry-brick');
                if (countMasonryBrick.length == attrs.ngcount) {
                    var grid = jQuery('#container-dashboard .page-content').masonry({
                        itemSelector: '.masonry-brick',
                        gutter: 20
                    });
                    grid.masonry('layout');
                }
            }
        },
        template: '<div ng-include="getContentUrl()" onload="initMasonry()"></div>'
    };
});

app.directive("strToTime", function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelController) {
            ngModelController.$parsers.push(function (data) {
                if (!data)
                    return "";
                return ("0" + data.getHours().toString()).slice(-2) + ":" + ("0" + data.getMinutes().toString()).slice(-2);
            });

            ngModelController.$formatters.push(function (data) {
                if (!data) {
                    return null;
                }
                var d = new Date(1970, 1, 1);
                var splitted = data.split("T")[1].split(":");

                d.setHours(splitted[0]);
                d.setMinutes(splitted[1]);
                return d;
            });
        }
    };
});

